module.exports = __webpack_public_path__ + "img/42_scrabble-x.aa18ab65.jpg";